import React, { PureComponent } from 'react';
import { v4 as generateUUID } from 'uuid';
import PropTypes from 'prop-types';
import QuestionGroup from './QuestionGroup';
import { QUESTION_GROUP_IDS } from './redux/constants';

class QuestionSection extends PureComponent {
  /**
   * Handles parsing this sections data and updates main form OpportunityPage
   * At this point we notify
   * @param {object} answers - an object of question id => answer
   * @param {string} _ - unused identifier (groupId)
   * @param {boolean} areAllFieldsValid
   */
  handleEvent = (answers, _, areAllFieldsValid) => {
    const { eventHandler, sectionId } = this.props;

    // each section is responsible for parsing its data to match POST request
    const parsedAnswers = Object.keys(answers).map((questionId) => {
      const { value, coachingFormType } = answers[questionId];

      // since questionId was an object key, it implicitly became a string; we convert back to num
      return {
        answer: value,
        question: { id: parseInt(questionId, 10), coachingFormType },
      };
    });

    // update main form
    eventHandler({ answers: parsedAnswers }, sectionId, areAllFieldsValid);
  }

  render() {
    const { questions, answeredQuestions, isErrorTriggered, isCompleted, isDisabled, coachingFormType } = this.props;

    return (
      <div className="ac-question-section">
        {answeredQuestions && Object.values(answeredQuestions).map((groupOfQuestions) => {
          return (
            <QuestionGroup
              isDisabled
              key={generateUUID()}
              coachingFormType={coachingFormType}
              questions={groupOfQuestions}
              isErrorTriggered={isErrorTriggered}
              groupId={QUESTION_GROUP_IDS.inactiveQuestions}
              />
              );
            })}
        {!isCompleted && (
          <QuestionGroup
            isDisabled={isDisabled}
            questions={questions}
            coachingFormType={coachingFormType}
            eventHandler={this.handleEvent}
            submitAnswers={this.submitAnswers}
            isErrorTriggered={isErrorTriggered}
            groupId={QUESTION_GROUP_IDS.activeQuestions}
          />
        )}
      </div>
    );
  }
}

QuestionSection.propTypes = {
  questions: PropTypes.array,
  answeredQuestions: PropTypes.oneOfType([ PropTypes.array, PropTypes.object ]),
  sectionId: PropTypes.string.isRequired,
  coachingFormType: PropTypes.number.isRequired,
  eventHandler: PropTypes.func.isRequired,
  isErrorTriggered: PropTypes.bool.isRequired,
};

QuestionSection.defaultProps = {
  questions: null,
  answeredQuestions: null,
};

export default QuestionSection;



// WEBPACK FOOTER //
// ./src/features/agent-coaching/QuestionSection.js